module.exports = __webpack_public_path__ + "img/lxwf.aeb23132.png";